import * as actionTypes from '../actions/actionTypes';
import {updateState} from "../../shared/util";

const initialState = {
    corporateBundle: null,
    loading: false,
    error: null,
    orderForm: null
};

const getCorporateBundleRequest = (state, action) => {
    return updateState(state, {
        loading: true
    })
};

const getCorporateBundleSuccess = (state, action) => {
    return updateState(state, {
        loading: false,
        corporateBundle: action.bundle
    })
};

const getCorporateBundleError = (state, action) => {
    return updateState(state, {
        error: action.error
    })
};

const getOrderFormFromCuidRequest = (state, action) => {
    return updateState(state, {
        loading: true
    })
};

const getOrderFormFromCuidSuccess = (state, action) => {
    return updateState(state, {
        loading: false,
        orderForm: action.data
    })
};

const getOrderFormFromCuidError = (state, action) => {
    return updateState(state, {
        error: action.error
    })
};

export function corporateBundleReducer(state=initialState, action) {
    switch(action.type) {
        case actionTypes.GET_CORPORATE_BUNDLE_REQUEST :
            return getCorporateBundleRequest(state, action);

        case actionTypes.GET_CORPORATE_BUNDLE_SUCCESS :
            return getCorporateBundleSuccess(state, action);

        case actionTypes.GET_CORPORATE_BUNDLE_ERROR :
            return getCorporateBundleError(state, action);
        case actionTypes.GET_ORDER_FROM_CUID_REQUEST :
            return getOrderFormFromCuidRequest(state, action);

        case actionTypes.GET_ORDER_FROM_CUID_SUCCESS :
            return getOrderFormFromCuidSuccess(state, action);

        case actionTypes.GET_ORDER_FROM_CUID_ERROR :
            return getOrderFormFromCuidError(state, action);
        default : return state;
    }
}